module.exports = __webpack_public_path__ + "static/media/universitas_airlangga_logo.73196502.png";